import React, {useState} from 'react';
import {I18n} from 'react-redux-i18n';
import {withStyles, WithStyles} from '@material-ui/core';
import {useDispatch} from 'react-redux';
import {CustomButton, CustomInput} from '../../material-dashboard-pro-react/components';

import {recoverTOTP} from './action';

import style from './style';

type RecoverTOTPFormProps = WithStyles<typeof style> & {
  onGoBack: () => void;
  onSuccess: () => void;
};

function RecoverTOTPForm({
  classes,
  onGoBack,
  onSuccess,
}: RecoverTOTPFormProps) {
  const dispatch = useDispatch();

  const [recoveryCode, setRecoveryCode] = useState('');
  const [errorText, setErrorText] = useState('');

  return (
    <div className={classes.recoverTOTP}>
      <CustomInput
        id="recovery-code"
        formControlProps={{fullWidth: true}}
        error={!!errorText}
        errorText={errorText}
        inputProps={{
          value: recoveryCode,
          name: 'recovery-code',
          onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
            setRecoveryCode(e.target.value);
            setErrorText('');
          },
          type: 'text',
          placeholder: I18n.t('loginPage2FA.recoveryCodePlaceholder'),
        }}
      />
      <p>
        {I18n.t('loginPage2FA.enterRecoveryCodeText')}
      </p>
      <div className={classes.recoverTOTP__buttons}>
        <CustomButton
          color="primary"
          customClasses="unauthorizedForm__button"
          onClick={onGoBack}
        >
          {I18n.t('loginPage2FA.recoveryCodeBack')}
        </CustomButton>
        <CustomButton
          disabled={!recoveryCode}
          color="secondary"
          customClasses="unauthorizedForm__button"
          onClick={() => {
            recoverTOTP(recoveryCode, (isSuccess) => {
              if (isSuccess) {
                onSuccess();
              } else {
                setErrorText(I18n.t('loginPage2FA.invalidRecoveryCode'));
              }
            })(dispatch);
          }}
        >
          {I18n.t('loginPage2FA.enterRecoveryCodeButton')}
        </CustomButton>
      </div>
    </div>
  );
}

export default withStyles(style)(RecoverTOTPForm);
